import InlineComponent from './inlineComponent.jsx';
import React from 'react';
import moment from 'moment-timezone';
import JsonPreview from '../../../components/JsonPreview.jsx';
import useToggle from '../../../components/hooks/useToggle.jsx';

function humanTimestamp(value) {
  const date = moment(value, moment.ISO_8601);
  return date.isValid()
    ? date.tz(moment.tz.guess()).format('dddd, MMMM Do YYYY, h:mm:ss a z')
    : value;
}

function RpmLogPreviewComponent(props) {
  const modalToggle = useToggle(false);
  const [fetchedCode, setFetchedCode] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(false);

  const code = props.code
    ? typeof props.code === 'string'
      ? JSON.parse(props.code)
      : props.code
    : fetchedCode;

  function handleClick() {
    if (props.showUrl && !fetchedCode) {
      setLoading(true);
      fetch(props.showUrl, { credentials: 'same-origin' })
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          setFetchedCode(data);
          modalToggle.toggle();
        })
        .catch(function () {
          setError(true);
        })
        .finally(function () {
          setLoading(false);
        });
    } else {
      modalToggle.toggle();
    }
  }

  return (
    <span>
      <button
        className='ui mini icon button'
        data-position={props.tooltipPosition || 'top right'}
        data-tooltip='Preview document'
        data-variation='mini'
        onClick={handleClick}
      >
        <i
          className={
            loading
              ? 'fa fa-spinner fa-spin'
              : error
                ? 'fa fa-exclamation-triangle'
                : 'fa fa-file-code-o'
          }
        ></i>
      </button>

      {code && (
        <JsonPreview
          code={code}
          name='log'
          open={modalToggle.value}
          title={humanTimestamp(props.title)}
          onClose={modalToggle.toggle}
        />
      )}
    </span>
  );
}

module.exports = class RpmLogPreview extends InlineComponent {
  define() {
    this.component = RpmLogPreviewComponent;
  }
};
